import React, { useCallback } from "react";

// region Molecules
import LanguageMenu from "@molecules/LanguageMenu";
import NotificationCenter from "@molecules/NotificationCenter";
// endregion Molecules
// region Atoms
import UserBadge from "@atoms/UserBadge";
// endregion Atoms
// region Libraries
import { Language, Logout } from "@libraries/mui/icons";
import { useMsal } from "@azure/msal-react";
// endregion Libraries
// region Hooks
import { useCurrentTenant } from "@hooks/useCurrentTenant";
// endregion Hooks
// region Languages
import { TLanguages } from "@languages/languageData";
// endregion Languages
// region Styled components
import * as Styled from "src/molecules/NavbarIcons/styles";
// endregion Styled components

const NavbarIcons: React.FC = () => {

  // region States
  const [languageElementAnchor, setLanguageElementAnchor] = React.useState<null | HTMLElement>(null);
  // endregion States

  const { instance } = useMsal();
  const { tenantName } = useCurrentTenant();

  const userName = instance.getActiveAccount()?.name ?? "";

  // region Handlers
  const handleLogoutClick = useCallback(() => {
    localStorage.removeItem("@Topcon:token");

    // Capture the account being logged out so B2C ends the session for the
    // right user, then drop the active-account reference up front. Without
    // both, the previous account can linger in the MSAL cache (sessionStorage)
    // and be re-selected on the next page load via getAllAccounts()[0],
    // leaking the prior user's token into acquireTokenSilent after a switch.
    const account = instance.getActiveAccount();

    instance.setActiveAccount(null);

    instance.logoutRedirect({
      account: account ?? undefined,
      postLogoutRedirectUri: "/"
    });
  }, [instance]);

  const handleLanguageClick = (event: React.MouseEvent<SVGSVGElement>) => {
    setLanguageElementAnchor(event.currentTarget.parentElement);
  };
  const handleLanguageClose = (_language: TLanguages) => setLanguageElementAnchor(null);
  // endregion Handlers

  return (
    <Styled.Container>
      <NotificationCenter />
      <Styled.LanguageIcon>
        <Language onClick={handleLanguageClick} />
        <LanguageMenu anchorElement={languageElementAnchor} onClose={handleLanguageClose} />
      </Styled.LanguageIcon>
      <Styled.Divider />
      <UserBadge name={userName} company={tenantName || undefined} />
      <Logout onClick={handleLogoutClick} />
    </Styled.Container>
  );
};

export default React.memo(NavbarIcons);
